import React from 'react';
import { CapturePropertyRobotDTO } from 'business/models/Models';
import RobotSettingsInput from '../robotSettingsInput';
import { getGeneralCurveField } from '../../utils';
import { frapPrefix } from '../../constants';
import { FrapConfigType } from '../../types';

interface FRAPGeneralProps {
  robotCaptureProperties: CapturePropertyRobotDTO;
  robotId: number;
  handleChange: (propertyName: string, value: any) => void;
  handleFieldToggle: (propertyName: string, value?: any) => void;
  enabledFields: string[];
  lightPath: string;
  frapConfig: FrapConfigType;
}

function FRAPGeneral(props: FRAPGeneralProps) {
  const {
    robotCaptureProperties,
    robotId,
    handleChange,
    handleFieldToggle,
    enabledFields,
    lightPath,
    frapConfig,
  } = props;
  const prefix = lightPath?.toUpperCase() === 'FRAP' ? frapPrefix : '';

  return (
    <div id={`frap-general-settings-${robotId}`} className="border p-2">
      <RobotSettingsInput
        key={1}
        field={getGeneralCurveField(prefix)}
        value={
          robotCaptureProperties.data[robotId]?.[
            getGeneralCurveField(prefix).PropertyName
          ]
        }
        onChange={handleChange}
        onToggle={handleFieldToggle}
        enabled={enabledFields.includes(getGeneralCurveField(prefix).PropertyName)}
        formData={robotCaptureProperties.data[robotId]}
        defaultValue={frapConfig?.[getGeneralCurveField(prefix).PropertyName]}
        customClassName="!w-[100%]"
      />
    </div>
  );
}

export default FRAPGeneral;
